import WithGASetup from '../../../components/WithGASetup';
import AuthContext from '../../../context/AuthContext.js';
import EditIntakeFormPage from './EditIntakeFormPage.js';

export default WithGASetup(EditIntakeFormPage, AuthContext);
